import useIsHasClothInPrize from '../../../../hooks/shared/quests/useIsHasClothInPrize';
import { CustomButton } from '../../../features/customButton';
import useOpenModalWithClothes from '../../../../hooks/shared/quests/useOpenModalWithClothes';
import { reset } from '../../../../utils/events/events';
import { tasksContent } from '../../../../constants/copyright';
import { useQuestPrize } from '../../../../hooks/shared/quests/useQuestPrize';

const {
  buttons: { showPrizes },
} = tasksContent;

export default function TaskItemShowPrizeClothesButton({ quest }) {
  const { mainPrize } = useQuestPrize(quest);
  const isHasCloth = useIsHasClothInPrize(mainPrize);

  const openModalWithClothes = useOpenModalWithClothes();

  return (
    isHasCloth && <CustomButton {...showPrizes} onClick={(e) => reset(e, () => openModalWithClothes(mainPrize))} />
  );
}
